import { Spinner } from '@frontend/components/common';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import LendingReviewResolve from '../lending-review-resolve/lending-review-resolve.component';
import VendingReviewResolve from '../vending-review-resolve/vending-review-resolve.component';
import useReviewResolve from './review-resolve.controller';

const ID = 'review-resolve';

const ReviewResolve = () => {
    const viewProps = useReviewResolve();

    if (viewProps.equipment) {
        return <LendingReviewResolve />;
    }
    if (viewProps.product) {
        return <VendingReviewResolve />;
    }

    return (
        <WizardScreenContainer id={ID}>
            <Spinner />
        </WizardScreenContainer>
    );
};

export default ReviewResolve;
